import { render } from "./ChooseBaseVoice.vue?vue&type=template&id=23b3a248&scoped=true"
import script from "./ChooseBaseVoice.vue?vue&type=script&lang=js"
export * from "./ChooseBaseVoice.vue?vue&type=script&lang=js"

import "./ChooseBaseVoice.vue?vue&type=style&index=0&id=23b3a248&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b3a248"]])

export default __exports__